import { action } from 'easy-peasy';
import { IActionSetLatestReadings } from '~/store/patient/types';

const setLatestReadings: IActionSetLatestReadings = action((state, payload) => {
  state.latestReadings = payload;
});

export default setLatestReadings;
